<template>
  <v-btn class="btn-primary" dark @click="acceptPayOutsidePlatform">
    <div class="text-btn">
      {{ $t('chat.ButtonAcceptPaymentOutsidePlatform') }}
    </div>
  </v-btn>
</template>

<script>
import ApiRepository from "../repositories/ApiRepository";
import {User} from "../models/user";
import Constants from "../../constants";

export default {
    name: "AcceptPaymentOutsitePlatform",
    props: {
        chat: {type: Object, required: true}
    },
    methods: {

        acceptPayOutsidePlatform () {
            let rectInvoice = null;
            let newCertification = null;
            let newContract = null;
            let invoiceStamp = null;
            if (this.chat.factoring) {
                ApiRepository.payerPaymentToReceiverUpdate(this.chat.factoring._id, Constants.FACTORING.STATUS_ACCEPTED, "", true)
                    .then(async () => {
                        rectInvoice = await ApiRepository.generateRectifyingInvoice(this.chat._id);
                        newCertification = await ApiRepository.generateNewCertification(this.chat._id);
                        newContract = await ApiRepository.generateByppayContract(this.chat._id);
                        invoiceStamp = await ApiRepository.generateInvoiceStamp(this.chat._id);

                        ApiRepository.setInvoicePercentage('invoice_payed', this.chat.invoice._id).then(() => {
                            ApiRepository.sendMessage("0", this.chat._id, JSON.stringify({message: 'chat.acceptPaymentOutsidePlatform', extraMessage: 'chat.acceptPaymentOutsidePlatformExtra', params: {user: (new User(this.$user)).getSingleName()}}),  'chat.acceptPaymentOutsidePlatform').then(() => {
                            });
                            ApiRepository.sendMessage("0", this.chat._id, JSON.stringify({message: 'chat.invoiceGenerated', extraMessage: 'chat.invoiceGeneratedExtra', params: {user: newCertification.data.user}}),  'chat.invoiceGenerated').then(async () => {

                                if (newContract !== null) {
                                    await ApiRepository.getFilename(newContract.data.invoice._id.toString()).then((res) => {
                                        ApiRepository.sendFile(this.$user._id.toString(), this.chat._id, "", res.data.fileName).then(() => {
                                        });
                                    });
                                }
                                if (rectInvoice !== null) {
                                    await ApiRepository.getFilename(rectInvoice.data.invoice._id.toString()).then((res) => {
                                        ApiRepository.sendFile(this.$user._id.toString(), this.chat._id, "", res.data.fileName).then(() => {
                                        });
                                    });
                                }
                                if (newCertification !== null) {
                                    await ApiRepository.getFilename(newCertification.data.invoice._id.toString()).then((res) => {
                                        ApiRepository.sendFile(this.$user._id.toString(), this.chat._id, "", res.data.fileName).then(() => {
                                        });
                                    });
                                }
                                if (invoiceStamp != null) {
                                    ApiRepository.sendFile(this.$user._id.toString(), this.chat._id, "", invoiceStamp.data.invoice.originalName).then(() => {
                                    });
                                    ApiRepository.sendFile(this.$user._id.toString(), this.chat._id, "", invoiceStamp.data.invoicePayed.originalName).then(() => {
                                    });
                                }

                                this.message = "";
                                this.fetch();
                            });
                            this.$emit('accepted');
                        });
                    })
                    .catch((err) => {
                        this.$root.$emit('show-snackbar', {message: this.$t('Error changing the payment status'), color: 'error'});
                    });
            } else {
                ApiRepository.invoicePayedOutsidePlatform(this.chat.invoice._id)
                    .then(() => {
                        this.$emit('sendSystemHour');
                        ApiRepository.setInvoicePercentage('invoice_payed', this.chat.invoice._id).then(() => {
                            ApiRepository.sendMessage("0", this.chat._id, JSON.stringify({
                                message: 'chat.acceptPaymentOutsidePlatform',
                                extraMessage: 'chat.acceptPaymentOutsidePlatformExtra',
                                params: {user: (new User(this.$user)).getSingleName()}
                            }),  'chat.acceptPaymentOutsidePlatform').then(() => {
                            });
                            this.$emit('accepted');
                        });
                    }).catch((err) => {
                        console.log(err);
                        this.$root.$emit('show-snackbar', {
                            message: this.$t('Error changing the payment status'),
                            color: 'error'
                        });
                    });
            }

        },
    }
};
</script>

<style scoped>

</style>
